import { listVal } from "@paroi/data-formatters-lib";
import type { PaginationOptions } from "../domain/pagination";
import type { CreateReferenceInput } from "../domain/reference";
import { fetchQuery } from "../shared/http-client";
import { type Reference, formatToReference } from "./reference.formatter";

export async function createReferenceAPI(reference: CreateReferenceInput): Promise<Reference> {
  const res = await fetchQuery("references", {
    method: "POST",
    body: JSON.stringify(reference),
  });
  if (!res) throw new Error("No data returned from createReferenceAPI");
  return formatToReference(res.data);
}

export async function fetchReferencesAPI(options: PaginationOptions): Promise<Reference[]> {
  const res = await fetchQuery(`references?limit=${options.limit}&page=${options.page}`);
  return listVal(res.data, formatToReference);
}

export async function searchReferencesAPI(query: string): Promise<Reference[]> {
  const res = await fetchQuery(`references/search?query=${encodeURIComponent(query)}`);
  return listVal(res.data, formatToReference);
}

export async function fetchOneReferenceAPI(id: number): Promise<Reference> {
  const res = await fetchQuery(`references/${id}`);
  return formatToReference(res.data);
}

export async function deleteReferenceAPI(id: number): Promise<void> {
  await fetchQuery(`references/${id}`, {
    method: "DELETE",
  });
}

export async function updateReferenceAPI(
  id: number,
  reference: CreateReferenceInput,
): Promise<Reference> {
  const res = await fetchQuery(`references/${id}`, {
    method: "PUT",
    body: JSON.stringify(reference),
  });
  if (!res) throw new Error("No data returned from updateReferenceAPI");
  return formatToReference(res.data);
}

export async function publishReferenceAPI(referenceId: number): Promise<void> {
  await fetchQuery(`references/${referenceId}/published`);
}
export async function generateReferenceDatabaseAPI(referenceId: number): Promise<void> {
  await fetchQuery(`references/${referenceId}/generate-database`);
}
